(function ($) {
	class W4D_Orders {
		constructor() {
			this.bindEvents();
		}

		bindEvents() {
			document.addEventListener(
				'command',
				(event) => {
					// Since event.target is the element being commanded, this finds the container instantly
					const $dropdown = $(event.target).closest('.dropdown');
					const command = event.command;
					const orderId = $dropdown.data('order-id') || $(event.source).data('order-id');

					if (!command || !orderId) return;

					this.handleOrderCommand(command, orderId, event.source);
				},
				{ capture: true }
			);
		}

		handleOrderCommand(command, orderId, sourceButton) {
			switch (command) {
				case '--view-details':
					const baseUrl = $(sourceButton).data('url');
					if (baseUrl) {
						window.location.href = `${baseUrl}?id=${orderId}`;
					}
					break;
				case '--repeat-order':
					this.handleRepeatOrderAction(orderId);
					break;
				case '--archive-order':
				case '--unarchive-order':
					const isUnarchive = command === '--unarchive-order';
					this.executeArchivingAction(orderId, isUnarchive, sourceButton);
					break;
			}
		}

		executeArchivingAction(orderId, isUnarchive, sourceButton) {
			const action = isUnarchive ? 'de_arhiviraj_narudzbu' : 'arhiviraj_narudzbu';

			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: {
					action: action,
					order_id: orderId,
				},
				success: (response) => {
					const message = response.data.message;
					if (response.success) {
						const $triggerRow = $(`.dropdown-trigger[data-order-id="${orderId}"]`).closest('.data-table__row');
						$triggerRow.fadeOut();
						W4D_Toast.showToast('success', message);

						// Order history: reload the current page so it refills and counts/pagination stay correct.
						if (window.W4D_Pagination && document.querySelector('[data-js-orders-table]')) {
							window.W4D_Pagination.fetchPovijestNarudzbi(true, { scroll: false });
						}

						const popoverDOM = sourceButton
							? sourceButton.closest('[popover]') || document.getElementById(sourceButton.getAttribute('popovertarget'))
							: null;

						if (popoverDOM && typeof popoverDOM.hidePopover === 'function') {
							popoverDOM.hidePopover();
						}
					} else {
						W4D_Toast.showToast('error', message);
					}
				},
			});
		}

		handleRepeatOrderAction(orderId) {
			const ajaxData = {
				action: 'w4d_add_order_items_to_cart',
				order_number: orderId,
				nonce: w4d_frontend_ajax.nonce,
			};

			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: ajaxData,
				success: (response) => {
					if (response.success) {
						W4D_Toast.showToast('success', 'Stavke narudžbe #' + orderId + ' uspješno dodane u košaricu.');
						W4D_FrontendHelper.updateCartIcon(response.data.cart_count);
					} else {
						W4D_Toast.showToast('error', response.data.message);
					}
				},
				error: () => {
					W4D_Toast.showToast('error', 'Došlo je do greške. Pokušajte ponovno.');
				},
			});
		}
	}

	$(document).ready(() => {
		new W4D_Orders();
	});
})(jQuery);
